import { HeadingNode, QuoteNode } from '@lexical/rich-text';
import { CodeHighlightNode, CodeNode } from '@lexical/code';
import { AutoLinkNode, LinkNode } from '@lexical/link';
import { ListItemNode, ListNode } from '@lexical/list';

/**
 * The Lexical editor config for the Page Builder Rich Text editor.
 */
const EditorConfig = {
    theme: {
        placeholder: 'editor-placeholder',
        paragraph: 'editor-paragraph',
        quote: 'editor-quote',
        heading: {
            h2: 'editor-heading-h2',
            h3: 'editor-heading-h3',
            h4: 'editor-heading-h4',
            h5: 'editor-heading-h5',
            h6: 'editor-heading-h6',
        },
        list: {
            nested: {
                listitem: 'editor-nested-listitem',
            },
            ol: 'editor-list-ol',
            ul: 'editor-list-ul',
            listitem: 'editor-listitem',
        },
        link: 'editor-link',
        text: {
            bold: 'editor-text-bold',
            italic: 'editor-text-italic',
            underline: 'editor-text-underline',
        },
    },
    onError: (error: Error) => {
        throw error;
    },
    nodes: [
        HeadingNode,
        ListNode,
        ListItemNode,
        QuoteNode,
        CodeNode,
        CodeHighlightNode,
        AutoLinkNode,
        LinkNode,
    ],
};

export default EditorConfig;
